export default (props) => (
    <AppInput
        labelClass={"focus-label"}
        controlClass="floating"
        {...props}
        labelpos="bottom"
        className={"form-focus "+(props?.className||'')}
    >
    </AppInput>
)